import MainAddress from "../";
import axios from "axios";

export async function GetHeadInvoice(data) {
  try {
    const response = await axios.post(
      MainAddress + "read_headInvoice.php",
      data
    );

    console.log(response.data);
    if (response.data[0].success) {
      return {
        success: response.data[0].success,
        data: response.data,
      };
    } else {
      return {
        success: false,
        message: "مشکلی هنگام دریافت اطلاعات به وجود آمد",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error,
    };
  }
}

export async function GetDetailInvoice(shomInvoice) {
    try {
      const response = await axios.post(
        MainAddress + "read_detailInvoice.php",
        {
          shomInvoice: shomInvoice,
        }
      );
  
      console.log(response.data);
      if (response.data[0].success) {
        return {
          success: response.data[0].success,
          data: response.data,
        };
      } else {
        return {
          success: false,
          message: "مشکلی هنگام دریافت اطلاعات به وجود آمد",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error,
      };
    }
  }